var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row h-100" }, [
    _c("div", { staticClass: "col-12 d-none d-md-block col-md-5" }, [
      _c("div", { staticClass: "left__auth_block" }, [
        _c(
          "a",
          { staticClass: "header__logo", attrs: { href: _vm.homelink } },
          [_c("img", { attrs: { src: "/img/logo_white.png", alt: "" } })]
        ),
        _vm._v(" "),
        _c("h2", { staticClass: "mb-4" }, [
          _vm._v(_vm._s(_vm.get_translation_constant("text_no_account"))),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn__medium btn__black mb-4",
            attrs: { href: _vm.registerlink },
          },
          [_vm._v(_vm._s(_vm.get_translation_constant("text_signup")))]
        ),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm.get_translation_constant("text_get_free_postal_address"))
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12 col-md-6 offset-md-1 col-lg-5 offset-lg-2" },
      [
        _c("h2", [
          _vm._v(_vm._s(_vm.get_translation_constant("text_login_to_account"))),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.login()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "form__col", class: _vm.hasError("email") },
              [
                _c("label", { attrs: { for: "email" } }, [
                  _vm._v(_vm._s(_vm.get_translation_constant("text_email"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.email,
                      expression: "form.email",
                    },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "email",
                    name: "email",
                    type: "email",
                    placeholder:
                      _vm.get_translation_constant("text_entry_email"),
                  },
                  domProps: { value: _vm.form.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.hasErrorMessage("email")
                  ? _c("div", { staticClass: "form__error" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.hasErrorMessage("email")) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form__col",
                class: _vm.hasError("password") || _vm.hasError("location"),
              },
              [
                _c("label", { attrs: { for: "password" } }, [
                  _vm._v(_vm._s(_vm.get_translation_constant("text_password"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.password,
                      expression: "form.password",
                    },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "password",
                    name: "password",
                    type: "password",
                    placeholder: _vm.get_translation_constant(
                      "text_entry_password"
                    ),
                  },
                  domProps: { value: _vm.form.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "password", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.hasErrorMessage("password")
                  ? _c("div", { staticClass: "form__error" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.hasErrorMessage("password")) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasErrorMessage("location")
                  ? _c("div", { staticClass: "form__error" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_location_error_login_message"
                            )
                          ) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.facebookloginerror === "has-error"
                  ? _c(
                      "div",
                      {
                        staticClass: "form__error",
                        staticStyle: { display: "block" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_facebook_login_error"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "form__col d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "forgot_link",
                    attrs: { href: _vm.forgottenlink },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.get_translation_constant("text_forgot_password")
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn__medium btn__green",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.login.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.get_translation_constant("text_login")) +
                        "\n                "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__hr_line" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.get_translation_constant("text_or"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__col form__col_last" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn__block btn__medium btn__facebook",
                  attrs: { href: _vm.socialloginurl },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "11",
                        height: "21",
                        viewBox: "0 0 11 21",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M9.64 11.08l.44-3.56H6.7V5.25c0-1.03.28-1.73 1.7-1.73h1.81V.34A23.2 23.2 0 007.56.2c-2.62 0-4.4 1.66-4.4 4.7v2.62H.2v3.56h2.96v9.12h3.53v-9.12h2.95z",
                          fill: "#fff",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n                    Facebook login"),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 d-md-none col-md-5 mt-5" }, [
      _c("h5", [
        _vm._v(_vm._s(_vm.get_translation_constant("text_facebook_login"))),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: _vm.registerlink } }, [
          _vm._v(_vm._s(_vm.get_translation_constant("text_signup"))),
        ]),
        _vm._v(
          ",\n            " +
            _vm._s(_vm.get_translation_constant("text_get_free_postal_address"))
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }